import { render } from "./Demographics.vue?vue&type=template&id=20a5e033"
import script from "./Demographics.vue?vue&type=script&lang=ts"
export * from "./Demographics.vue?vue&type=script&lang=ts"

import "./Demographics.vue?vue&type=style&index=0&id=20a5e033&lang=scss"
script.render = render

export default script